import ApplicationController from "./application_controller";
import { EsriProvider } from "leaflet-geosearch";

import axios from "axios";
import { ENDPOINT, ROOT_URL, FILTERS, VELIB_API, DEFAULT_COORDS } from "../util/transport_config.js";

export default class extends ApplicationController {
  static targets = [
    "latitude",
    "longitude",
    "railway",
    "street",
    "velib",
    "transport",
    "streetAddress",
    "postcodeAddress",
    "cityAddress",
  ];

  connect() {
    this.token = "46475388-c255-434e-a3c9-d40b476e4666";
    this._renderTransports();
  }

  updateAddress() {
    return new Promise((resolve) => {
      resolve();

      this._buildAddress().then((response) => resolve(response));
    });
  }

  // PRIVATE
  _buildAddress() {
    return new Promise((resolve) => {
      const street = this.streetAddressTarget.value;
      const postcode = this.postcodeAddressTarget.value;
      const city = this.cityAddressTarget.value;

      this.address = street && postcode && city ? `${street}, ${postcode}, ${city}` : "";

      if (this.address !== "") {
        this._searchAddress().then(() => {
          // map ->
          this.mapController ||= this.application.getControllerForElementAndIdentifier(this.element, "geo-picker");
          this.mapController.updatePicker({ lat: this.coords[0], lng: this.coords[1] });
          // transports ->
          this._requestAPIs(this.coords[0], this.coords[1]).then(() => {
            resolve();
          });
        });
      } else {
        resolve("Incomplete Address");
      }
    });
  }

  _searchAddress() {
    const provider = new EsriProvider();
    return provider
      .search({ query: this.address || "" })
      .then((result) => (this.coords = result.length > 0 && [result[0].y, result[0].x]))
      .catch(() => (this.coords = DEFAULT_COORDS));
  }

  _requestAPIs(lat, lng) {
    // const path = `coverage/fr-idf/coord/${lng}%3B${lat}/`;
    const queries = [
      // {
      //   url: `${ROOT_URL}${path}${ENDPOINT}?${FILTERS}&distance=2000&type%5B%5D=stop_area&filter=physical_mode.id%3Dphysical_mode%3AMetro%20or%20physical_mode.id%3Dphysical_mode%3ARapidTransit%20or%20physical_mode.id%3Dphysical_mode%3ALocalTrain&count=3`,
      //   modes: ["physical_mode:Metro", "physical_mode:RapidTransit", "physical_mode:LocalTrain"],
      //   type: "railway",
      // },
      // {
      //   url: `${ROOT_URL}${path}${ENDPOINT}?${FILTERS}&distance=2000&count=1&type%5B%5D=stop_area&filter=physical_mode.id%3Dphysical_mode%3ABus%20or%20physical_mode.id%3Dphysical_mode%3ATramway&count=1`,
      //   modes: ["physical_mode:Bus", "physical_mode:Tramway"],
      //   type: "street",
      // },
      {
        url: `${VELIB_API}&rows=1&geofilter.distance=${lat},+${lng}, +1000`,
        label: "Vélib",
      },
    ];

    return new Promise((resolve) => {
      this._runAll(queries).then(() => resolve());
    });
  }

  _runAll(endpoints_params) {
    this._clearTargetsHtml();
    return Promise.all(endpoints_params.map((item) => this._axiosQuery(item))).then((stop_areas) => {
      // Wait for all axios request & then ...
      // const resultFromNavitia = stop_areas.filter((res) => res.modes); // Metro, RER, train, bus, tramway from Navitia API
      const resultFromOpenData = stop_areas.filter((res) => !res.modes); // Velib from opendata Paris

      this.transportsJson = [];

      // resultFromNavitia.forEach((item) => {
      //   if (!item.data || !item.data.places_nearby) return;

      //   const title = item.type === "railway" ? "Metro, RER, train" : "Bus, tramway";
      //   const target = item.type === "railway" ? this.railwayTarget : this.streetTarget;

      //   const transportLines = this._buildRailsAndStreetsLines(item.data.places_nearby, item);
      //   this._renderCard(title, transportLines.map((item) => item.render).join(" "), target);
      // });

      resultFromOpenData.forEach((item) => {
        if (item.data.records.length === 0) return;
        const name = item.data.records[0].fields.name;
        const distance = Number(item.data.records[0].fields.dist).toFixed(2);

        this.transportsJson = this._buildTransportJson({ navitia: false, item, name, distance });
        this._renderCard(
          "Vélib",
          [`<li>${this._formatName(name)} <small>(${distance}m)</small></li>`],
          this.velibTarget
        );
      });

      this.transportTarget.setAttribute("value", JSON.stringify(this.transportsJson));
    });
  }

  _buildRailsAndStreetsLines(places_nearby, item) {
    return places_nearby.map((transport) => {
      const linesObject = this._buildLines(transport, item);
      this.transportsJson = this._buildTransportJson({ navitia: true, item, transport, linesObject });
      const pictos = this._buildPictos(linesObject);

      return {
        distance: transport.distance,
        render: `<li>${pictos} ${this._formatName(transport.name)} <small>(${transport.distance}m)</small></li>`,
      };
    });
  }

  _buildLines(transport, item) {
    return transport.stop_area.lines
      .filter((line) => item.modes.includes(line.physical_modes[0].id))
      .map((line) => {
        return { color: line.color, code: line.code };
      });
  }

  _buildPictos(linesObject) {
    return linesObject
      .map((line) => {
        return `<span class="rounded-circle transport-picto" style="background-color: #${line.color};">${line.code}</span>`;
      })
      .join(" ");
  }

  _buildTransportJson(options) {
    if (options.navitia) {
      return [
        ...this.transportsJson,
        {
          type: options.item.type,
          name: this._formatName(options.transport.name),
          distance: options.transport.distance,
          lines: options.linesObject,
          coord: [Number(options.transport.stop_area.coord.lat), Number(options.transport.stop_area.coord.lon)],
        },
      ];
    } else {
      return [
        ...this.transportsJson,
        {
          type: options.item.type,
          name: this._formatName(options.name),
          distance: options.distance,
          coord: [
            options.item.data.records[0].geometry.coordinates[1],
            options.item.data.records[0].geometry.coordinates[0],
          ],
        },
      ];
    }
  }

  _axiosQuery(item) {
    const options = {
      method: "get",
      url: item.url,
      dataType: "json",
    };

    if (item.modes) {
      options.headers = {
        Authorization: "Basic " + btoa(this.token),
      };
    }

    return new Promise((resolve) => {
      axios(options)
        .then((response) => {
          resolve({ data: response.data, type: item.type, modes: item.modes });
        })
        .catch((error) => console.log(error));
    });
  }

  _renderTransports() {
    const transports = this.hasTransportTarget && this.transportTarget ? this.transportTarget.dataset.transports : null;
    if (transports === "{}" || !transports) return;

    const allTransports = JSON.parse(this.transportTarget.dataset.transports);
    const railsway = allTransports.filter((item) => item.type === "railway");
    const streetway = allTransports.filter((item) => item.type === "street");
    const velib = allTransports.filter((item) => item.type !== "street" && item.type !== "railway");

    [railsway, streetway].forEach((item) => {
      const title = item[0].type === "railway" ? "Metro, RER, train" : "Bus, tramway";
      const target = item[0].type === "railway" ? this.railwayTarget : this.streetTarget;

      const transportLines = item.map((transport) => {
        const pictos = this._buildPictos(transport.lines);
        return `<li>${pictos} ${this._formatName(transport.name)} <small>(${transport.distance}m)</small></li>`;
      });

      this._renderCard(title, transportLines.join(" "), target);
    });

    [velib].forEach((transport) => {
      transport.forEach((item) => {
        const name = item.name;
        const distance = item.distance;

        this._renderCard(
          "Vélib",
          [`<li>${this._formatName(name)} <small>(${distance}m)</small></li>`],
          this.velibTarget
        );
      });
    });
  }

  _renderCard(title, content, target) {
    target.innerHTML = `<div class="card mb-3">
      <div class="card-body">
        <h5 class="card-title">${title}</h5>
        <ul class="transport-list">${content}</ul>
      </div>
    </div>`;
  }

  _clearTargetsHtml() {
    this.railwayTarget.innerHTML = "";
    this.streetTarget.innerHTML = "";
    this.velibTarget.innerHTML = "";
  }

  _formatName(name) {
    return name.replace(/(\(Paris\))/g, "");
  }
}
